import * as Yup from 'yup';

export interface Field {
    name: string;
    label: string;
    type: string;
    position?: number;
    placeholder?: string;
    options?: { value: any; label: string }[];
    hidden?: (values: any) => boolean;
}

export const getShopFields = (): Field[] => [
    {
        name: 'name',
        label: 'Название',
        type: 'text',
        placeholder: 'Укажите название магазина',
        position: 10,
    },
    {
        name: 'about',
        label: 'Описание',
        type: 'textarea',
        placeholder: 'Укажите описание магазина',
        position: 20,
    },
    {
        name: 'photo_url',
        label: 'Фото магазина',
        type: 'image',
    },
    {
        name: 'type',
        label: 'Тип магазина',
        type: 'select',
        position: 40,
        options: [
            { value: 0, label: 'Интернет магазин' },
            { value: 1, label: 'Wildberries витрина' },
            { value: 2, label: 'Ozon витрина' },
        ],
    },
    {
        name: 'price_from',
        label: 'Указывать цену “от”',
        type: 'switch',
        position: 30,
        hidden: values => values.type !== 0,
    },
    {
        name: 'create_type',
        label: 'Метод создания',
        type: 'select',
        position: 40,
        options: [
            { value: 'link', label: 'Ссылка на магазин' },
            { value: 'api', label: 'По API ключу' },
        ],
        hidden: values => values.type !== 1,
    },
    {
        name: 'feed_url',
        label: 'Ссылка',
        type: 'text',
        placeholder: 'https://wildberries.ru/seller/212',
        position: 30,
        hidden: values => !(values.type === 1 && values.create_type === 'link'),
    },
    {
        name: 'api_key',
        label: 'API ключ',
        type: 'text',
        position: 30,
        hidden: values => !(values.type === 1 && values.create_type === 'api'),
    },
    {
        name: 'client_id',
        label: 'Client ID',
        type: 'text',
        position: 30,
        hidden: values => values.type !== 2,
    },
    {
        name: 'api_key',
        label: 'API ключ',
        type: 'text',
        position: 30,
        hidden: values => values.type !== 2,
    },
];
export const validationSchema = Yup.object({
    name: Yup.string()
        .max(255, 'Слишком длинное название')
        .required('Поле обязательно'),
    about: Yup.string().nullable().max(1000, 'Слишком длинное описание'),
});
